import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationPaymentPageDisplayType } from 'src/app/interfaces/paymentPage/application-payment-page-display-type.enum';
import { ApplicationPaymentPageFormData } from 'src/app/interfaces/paymentPage/application-payment-page-form-data';
import { GetApplicationPaymentPageSettings } from 'src/app/interfaces/paymentPage/get-application-payment-page-settings';
import { GetMerchantInformation } from 'src/app/interfaces/paymentPage/get-merchant-information';
import { MerchantConfiguration } from 'src/app/interfaces/paymentPage/merchant-configuration';
import { PaymentPageService } from 'src/app/services/payment-page/payment-page.service';
import { SessionService } from 'src/app/services/session/session.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';

@Component({
  selector: 'app-channel-payment-page',
  templateUrl: './channel-payment-page.component.html',
  styleUrls: ['./channel-payment-page.component.scss']
})
export class ChannelPaymentPageComponent implements OnInit {
  private token:string;
  public displayTypes=ApplicationPaymentPageDisplayType;
  public paymentPageName:string;
  public merchantName:string;
  public paymentUrl:string;
  public paymentForm: FormGroup;
  public displayField = {
    amount:ApplicationPaymentPageDisplayType.hidden,
    contactDetailsFirstName:ApplicationPaymentPageDisplayType.hidden,
    contactDetailsLastName:ApplicationPaymentPageDisplayType.hidden,
    contactDetailsCompanyName:ApplicationPaymentPageDisplayType.hidden,
    contactDetailsContactNumber:ApplicationPaymentPageDisplayType.hidden,
    contactDetailsAlternativeContactNumber:ApplicationPaymentPageDisplayType.hidden,
    contactDetailsEmail:ApplicationPaymentPageDisplayType.hidden,
    billingAddressContact:ApplicationPaymentPageDisplayType.hidden,
    billingAddressCustomerId:ApplicationPaymentPageDisplayType.hidden,
    billingAddressInvoiceDescription:ApplicationPaymentPageDisplayType.hidden,
    billingAddressInvoiceId:ApplicationPaymentPageDisplayType.hidden,
    billingAddressAddress:ApplicationPaymentPageDisplayType.hidden,
    shippingAddressContact:ApplicationPaymentPageDisplayType.hidden,
    shippingAddressDeliveryEmail:ApplicationPaymentPageDisplayType.hidden,
    shippingAddressDeliveryTimeframe:ApplicationPaymentPageDisplayType.hidden,
    shippingAddressShippingMethod:ApplicationPaymentPageDisplayType.hidden,
    shippingAddressAddress:ApplicationPaymentPageDisplayType.hidden,
  };
  public merchantConfigStyle={
    backgroundImageUrl:"#f4f4f4",
    backgroundColour:'#fff',
    merchantHeaderLogo:'',
    virtualColourScheme:'#009dd3',
    label:''
  };
  public loading:boolean;
  public notHiddenElems:number;
  constructor(private formBuilder:FormBuilder,
    private transactionService:TransactionService,
    private paymentPageServie:PaymentPageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sessionService: SessionService
  ) {
    this.loading=true;
    this.paymentForm = new FormGroup({
      merchantReference:new FormControl('',Validators.required),
      amount:new FormControl('',[Validators.min(0)]),
      contactDetailsFirstName:new FormControl(''),
      contactDetailsLastName:new FormControl(''),
      contactDetailsCompanyName:new FormControl(''),
      contactDetailsContactNumber:new FormControl(''),
      contactDetailsAlternativeContactNumber:new FormControl(''),
      contactDetailsEmail:new FormControl(''),
      billingAddressContactFirstName:new FormControl(''),
      billingAddressContactLastName:new FormControl(''),
      billingAddressContactCompanyName:new FormControl(''),
      billingAddressContactContactNumber:new FormControl(''),
      billingAddressContactAlternativeContactNumber:new FormControl(''),
      billingAddressContactEmail:new FormControl(''),
      billingAddressCustomerId:new FormControl(''),
      billingAddressInvoiceDescription:new FormControl(''),
      billingAddressInvoiceId:new FormControl(''),
      billingAddressAddressLine1:new FormControl(''),
      billingAddressAddressLine2:new FormControl(''),
      billingAddressAddressLine3:new FormControl(''),
      billingAddressAddressLine4:new FormControl(''),
      billingAddressAddressLine5:new FormControl(''),
      billingAddressSurburb:new FormControl(''),
      billingAddressCity:new FormControl(''),
      billingAddressProvince:new FormControl(''),
      billingAddressCountryCode:new FormControl(''),
      billingAddressCountry:new FormControl(''),
      billingAddressPostalCode:new FormControl(''),
      shippingAddressContactFirstName:new FormControl(''),
      shippingAddressContactLastName:new FormControl(''),
      shippingAddressContactCompanyName:new FormControl(''),
      shippingAddressContactNumber:new FormControl(''),
      shippingAddressContactAlternativeNumber:new FormControl(''),
      shippingAddressDeliveryEmail:new FormControl(''),
      shippingAddressDeliveryTimeframe:new FormControl(''),
      shippingAddressShippingMethod:new FormControl(''),
      shippingAddressAddressLine1:new FormControl(''),
      shippingAddressAddressLine2:new FormControl(''),
      shippingAddressAddressLine3:new FormControl(''),
      shippingAddressAddressLine4:new FormControl(''),
      shippingAddressAddressLine5:new FormControl(''),
      shippingAddressSurburb:new FormControl(''),
      shippingAddressCity:new FormControl(''),
      shippingAddressProvince:new FormControl(''),
      shippingAddressCountryCode:new FormControl(''),
      shippingAddressCountry:new FormControl(''),
      shippingAddressPostalCode:new FormControl(''),
      token:new FormControl(''),
      merchantUid:new FormControl(''),
      applicationUid:new FormControl(''),
      currencyCode:new FormControl('')
    });
    const queryParams = activatedRoute.snapshot.queryParams;
    if(!queryParams['paymentPageUid']){
      this.errorHandler('Invalid payment page, please return to the merchant and try again');
    }
    else{
      sessionService.login()
      .subscribe((value)=>{
        sessionStorage.setItem('authToken', value['access_token']);
        // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.login.success', value['access_token'], 0);

        const token = queryParams['paymentPageUid'];
        this.token =token;
        this.notHiddenElems=0;
        paymentPageServie.getMerchantInformation(token).subscribe((res:GetMerchantInformation)=>{
          if(res!=null){
            paymentPageServie.getMerchantConfig(res.merchantUid,res.applicationUid).subscribe((res:MerchantConfiguration)=>{
              this.merchantConfigStyle.backgroundImageUrl = res.backgroundImageUrl!=null && res.backgroundImageUrl!='' ? res.backgroundImageUrl : this.merchantConfigStyle.backgroundImageUrl ;
              this.merchantConfigStyle.virtualColourScheme = res.virtualColorScheme!=null && res.virtualColorScheme!='' ? res.virtualColorScheme.replace(";","") : this.merchantConfigStyle.virtualColourScheme;
              this.merchantConfigStyle.backgroundColour = res.virtualDefaultColorScheme!=null && res.virtualDefaultColorScheme!='' ? res.virtualDefaultColorScheme.replace(";","") : this.merchantConfigStyle.backgroundColour;
              this.merchantConfigStyle.merchantHeaderLogo = res.merchantLogo;
              this.merchantConfigStyle.label = res.label;
            });

            this.paymentForm.controls['merchantUid'].setValue(res.merchantUid);
            this.paymentForm.controls['applicationUid'].setValue(res.applicationUid);
            this.paymentForm.controls['merchantReference'].setValue(res.merchantReference);
            this.paymentForm.controls['currencyCode'].setValue(res.currencyCode);
            this.paymentPageName = res.applicationPaymentPageName;
            this.merchantName = res.merchantName;
            this.paymentUrl = res.paymentUrl;

            paymentPageServie.getApplicationPaymentPageData(token).subscribe((res:GetApplicationPaymentPageSettings)=>{
              let isBillingContact = true;
              let billingContactCount=0;
              let isShippingContact = true;
              let shippingCounter = 0;
              for(let x of res.fieldList){
                switch(x.fieldCode){
                  case "AMOUNT":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      this.notHiddenElems++;
                    }
                    this.setDisplayFieldForValue("amount",x.displayCode,x.min,x.max,isNaN(x.defaultValue) ? 0 : x.defaultValue);
                    this.displayField.amount = this.getDisplayType(x.displayCode);
                    break;
                  case "CONTACT_FIRST_NAME":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      if(isBillingContact){
                        billingContactCount++;
                      }
                      if(isShippingContact){
                        shippingCounter++;
                      }
                    }

                    this.setDisplayField("billingAddressContactFirstName",x.displayCode,x.min,x.max,x.defaultString);
                    this.setDisplayField("shippingAddressContactFirstName",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.contactDetailsFirstName = this.getDisplayType(x.displayCode);
                    break;
                  case "CONTACT_LAST_NAME":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      if(isBillingContact){
                        billingContactCount++;
                      }
                      if(isShippingContact){
                        shippingCounter++;
                      }
                    }
                    this.setDisplayField("billingAddressContactLastName",x.displayCode,x.min,x.max,x.defaultString);
                    this.setDisplayField("shippingAddressContactLastName",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.contactDetailsLastName = this.getDisplayType(x.displayCode);
                    break;
                  case "CONTACT_COMPANY":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      if(isBillingContact){
                        billingContactCount++;
                      }
                      if(isShippingContact){
                        shippingCounter++;
                      }
                    }
                    this.setDisplayField("billingAddressContactCompanyName",x.displayCode,x.min,x.max,x.defaultString);
                    this.setDisplayField("shippingAddressContactCompanyName",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.contactDetailsCompanyName = this.getDisplayType(x.displayCode);
                    break;
                  case "CONTACT_NUMBER":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      if(isBillingContact){
                        billingContactCount++;
                      }
                      if(isShippingContact){
                        shippingCounter++;
                      }
                    }
                    this.setDisplayField("billingAddressContactContactNumber",x.displayCode,x.min,x.max,x.defaultString);
                    this.setDisplayField("shippingAddressContactNumber",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.contactDetailsContactNumber = this.getDisplayType(x.displayCode);
                    break;
                  case "CONTACT_ALTERNATIVE_NUMBER":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      if(isBillingContact){
                        billingContactCount++;
                      }
                      if(isShippingContact){
                        shippingCounter++;
                      }
                    }
                    this.setDisplayField("billingAddressContactAlternativeContactNumber",x.displayCode,x.min,x.max,x.defaultString);
                    this.setDisplayField("shippingAddressContactAlternativeNumber",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.contactDetailsAlternativeContactNumber = this.getDisplayType(x.displayCode);
                    break;
                  case "CONTACT_EMAIL":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      if(isBillingContact){
                        billingContactCount++;
                      }
                    }
                    this.setDisplayField("billingAddressContactEmail",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.contactDetailsEmail = this.getDisplayType(x.displayCode);
                    break;
                  case "BILLING_CONTACT":
                    this.displayField.billingAddressContact = this.getDisplayType(x.displayCode);
                    if(this.displayField.billingAddressContact!=this.displayTypes.edit){
                      isBillingContact = false;
                      shippingCounter = 0;
                    }
                    break;
                  case "BILLING_CUSTOMER_ID":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      this.notHiddenElems++;
                    }
                    this.setDisplayField("billingAddressCustomerId",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.billingAddressCustomerId = this.getDisplayType(x.displayCode);
                    break;
                  case "BILLING_INVOICE_ID":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      this.notHiddenElems++;
                    }
                    this.setDisplayField("billingAddressInvoiceId",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.billingAddressInvoiceId = this.getDisplayType(x.displayCode);
                    break;
                  case "BILLING_INVOICE_DESCRIPTION":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      this.notHiddenElems++;
                    }
                    this.setDisplayField("billingAddressInvoiceDescription",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.billingAddressInvoiceDescription = this.getDisplayType(x.displayCode);
                    break;
                  case "BILLING_ADDRESS":
                    this.setDisplayField("billingAddressAddressLine1",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("billingAddressAddressLine2",x.displayCode,x.min,x.max,"",false);
                    this.setDisplayField("billingAddressAddressLine3",x.displayCode,x.min,x.max,"",false);
                    this.setDisplayField("billingAddressAddressLine4",x.displayCode,x.min,x.max,"",false);
                    this.setDisplayField("billingAddressAddressLine5",x.displayCode,x.min,x.max,"",false);
                    this.setDisplayField("billingAddressSurburb",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("billingAddressCity",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("billingAddressProvince",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("billingAddressCountryCode",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("billingAddressCountry",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("billingAddressPostalCode",x.displayCode,x.min,x.max,"",null);
                    this.displayField.billingAddressAddress = this.getDisplayType(x.displayCode);
                    break;
                  case "SHIPPING_CONTACT":
                    this.displayField.shippingAddressContact = this.getDisplayType(x.displayCode);
                    if(this.displayField.shippingAddressContact!=this.displayTypes.edit){
                      isShippingContact = false;
                      shippingCounter = 0;
                    }
                    break;
                  case "SHIPPING_EMAIL":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      if(isShippingContact){
                        shippingCounter++;
                      }
                    }
                    this.setDisplayField("shippingAddressDeliveryEmail",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.shippingAddressDeliveryEmail = this.getDisplayType(x.displayCode);
                    break;
                  case "SHIPPING_DELIVERY_TIMEFRAME":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      this.notHiddenElems++;
                    }
                    this.setDisplayField("shippingAddressDeliveryTimeframe",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.shippingAddressDeliveryTimeframe = this.getDisplayType(x.displayCode);
                    break;
                  case "SHIPPING_METHOD":
                    if(this.getDisplayType(x.displayCode)==ApplicationPaymentPageDisplayType.edit){
                      this.notHiddenElems++;
                    }
                    this.setDisplayField("shippingAddressShippingMethod",x.displayCode,x.min,x.max,x.defaultString);
                    this.displayField.shippingAddressShippingMethod = this.getDisplayType(x.displayCode);
                    break;
                  case "SHIPPING_ADDRESS":
                    this.setDisplayField("shippingAddressAddressLine1",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("shippingAddressAddressLine2",x.displayCode,x.min,x.max,"",false);
                    this.setDisplayField("shippingAddressAddressLine3",x.displayCode,x.min,x.max,"",false);
                    this.setDisplayField("shippingAddressAddressLine4",x.displayCode,x.min,x.max,"",false);
                    this.setDisplayField("shippingAddressAddressLine5",x.displayCode,x.min,x.max,"",false);
                    this.setDisplayField("shippingAddressSurburb",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("shippingAddressCity",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("shippingAddressCountryCode",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("shippingAddressProvince",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("shippingAddressCountry",x.displayCode,x.min,x.max,"",null);
                    this.setDisplayField("shippingAddressPostalCode",x.displayCode,x.min,x.max,"",null);
                    this.displayField.shippingAddressAddress = this.getDisplayType(x.displayCode);
                    break;
                }
              }

              this.notHiddenElems += billingContactCount + shippingCounter;
              if(this.notHiddenElems==0){
                this.onSubmit(new Event(""));
              }
              else{
                if(this.displayField.shippingAddressContact!=this.displayTypes.edit){
                  this.paymentForm.controls["shippingAddressContactFirstName"].setValidators([]);
                  this.paymentForm.controls["shippingAddressContactLastName"].setValidators([]);
                  this.paymentForm.controls["shippingAddressContactCompanyName"].setValidators([]);
                  this.paymentForm.controls["shippingAddressContactNumber"].setValidators([]);
                  this.paymentForm.controls["shippingAddressContactAlternativeNumber"].setValidators([]);
                  this.paymentForm.controls["shippingAddressDeliveryEmail"].setValidators([]);
                  this.paymentForm.controls["shippingAddressContactFirstName"].updateValueAndValidity();
                  this.paymentForm.controls["shippingAddressContactLastName"].updateValueAndValidity();
                  this.paymentForm.controls["shippingAddressContactCompanyName"].updateValueAndValidity();
                  this.paymentForm.controls["shippingAddressContactNumber"].updateValueAndValidity();
                  this.paymentForm.controls["shippingAddressContactAlternativeNumber"].updateValueAndValidity();
                  this.paymentForm.controls["shippingAddressDeliveryEmail"].updateValueAndValidity();
                }
                if(this.displayField.billingAddressContact!=this.displayTypes.edit){
                  this.paymentForm.controls["billingAddressContactFirstName"].setValidators([]);
                  this.paymentForm.controls["billingAddressContactLastName"].setValidators([]);
                  this.paymentForm.controls["billingAddressContactCompanyName"].setValidators([]);
                  this.paymentForm.controls["billingAddressContactContactNumber"].setValidators([]);
                  this.paymentForm.controls["billingAddressContactAlternativeContactNumber"].setValidators([]);
                  this.paymentForm.controls["billingAddressContactEmail"].setValidators([]);
                  this.paymentForm.controls["billingAddressContactFirstName"].updateValueAndValidity();
                  this.paymentForm.controls["billingAddressContactLastName"].updateValueAndValidity();
                  this.paymentForm.controls["billingAddressContactCompanyName"].updateValueAndValidity();
                  this.paymentForm.controls["billingAddressContactContactNumber"].updateValueAndValidity();
                  this.paymentForm.controls["billingAddressContactAlternativeContactNumber"].updateValueAndValidity();
                  this.paymentForm.controls["billingAddressContactEmail"].updateValueAndValidity();
                }
                this.loading =false;
              }
            }, () => this.errorHandler('Please return to the merchant and try again'));
          }
          else{
            this.errorHandler('Invalid payment page, please return to the merchant and try again');
          }
        },()=>{
          this.errorHandler('Please return to the merchant and try again');
        });
      });
    }
  }

  ngOnInit(): void {
  }

  private getDisplayType(value:string):ApplicationPaymentPageDisplayType{
    if(value=="READ_ONLY"){
      return ApplicationPaymentPageDisplayType.readOnly;
    }
    else if(value=="EDIT"){
      return ApplicationPaymentPageDisplayType.edit;
    }
    else{
      return ApplicationPaymentPageDisplayType.hidden;
    }
  }

  private setDisplayField(field:string,displayType:string,min:number|undefined,max:number|undefined,defaultString:string|undefined,required:boolean=true){
    const validators = [];
    if(min!=undefined){
      validators.push(Validators.minLength(min));
    }
    if(max!=undefined){
      validators.push(Validators.maxLength(max));
    }
    // if(displayType=="READ_ONLY"){
    //   this.paymentForm.controls[field].disable();
    // }
    if(displayType==this.displayTypes.edit && required){
      validators.push(Validators.required);
      // this.paymentForm.controls[field].enable();
    }

    if(defaultString!=undefined){
      this.paymentForm.controls[field].setValue(defaultString);
    }

    this.paymentForm.controls[field].setValidators(validators);
    this.paymentForm.controls[field].updateValueAndValidity();
  }

  private setDisplayFieldForValue(field:string,displayType:string,min:number|undefined,max:number|undefined,defaultValue:number|undefined, required:boolean=true){
    console.log(field,displayType,min,max,defaultValue,required);
    const validators = [];
    if(min!=undefined){
      validators.push(Validators.min(min));
    }
    if(max!=undefined){
      validators.push(Validators.max(max));
    }
    // if(displayType=="READ_ONLY"){
    //   this.paymentForm.controls[field].disable();
    // }
    if(displayType==this.displayTypes.edit && required){
      validators.push(Validators.required);
      // this.paymentForm.controls[field].enable();
    }

    if(defaultValue!=undefined){
      this.paymentForm.controls[field].setValue(defaultValue);
    }

    this.paymentForm.controls[field].setValidators(validators);
    this.paymentForm.controls[field].updateValueAndValidity();
  }

  private errorHandler(message:string){
    this.router.navigate(['error?error='+encodeURIComponent('Oops something went wrong!')+'&errorDescription='+encodeURIComponent(message)]);
  }

  public onSubmit(event:Event){
    event.preventDefault();
    this.paymentPageServie.getJWToken(this.getFormData(),this.token).subscribe((res:{token:string|undefined})=>{
      this.paymentForm.controls['token'].setValue(res.token);
      this.paymentForm.updateValueAndValidity();
      document.forms[0].submit();
    },
    (err)=>{
      console.log(err);
    });
  }

  private getFormData():ApplicationPaymentPageFormData{
    return {
      cuid:this.paymentForm.controls["merchantUid"]!=undefined ? this.paymentForm.controls["merchantUid"].value : undefined,
      auid:this.paymentForm.controls["applicationUid"]!=undefined ? this.paymentForm.controls["applicationUid"].value : undefined,
      mref:this.paymentForm.controls["merchantReference"]!=undefined ? this.paymentForm.controls["merchantReference"].value : undefined,
      amount:this.paymentForm.controls["amount"]!=undefined ? this.paymentForm.controls["amount"].value : undefined,
      BillingContactFirstName:this.paymentForm.controls["billingAddressContactFirstName"]!=undefined ? this.paymentForm.controls["billingAddressContactFirstName"].value : undefined,
      BillingContactLastName:this.paymentForm.controls["billingAddressContactLastName"]!=undefined ? this.paymentForm.controls["billingAddressContactLastName"].value : undefined,
      BillingContactCompanyName:this.paymentForm.controls["billingAddressContactCompanyName"]!=undefined ? this.paymentForm.controls["billingAddressContactCompanyName"].value : undefined,
      BillingContactNumber:this.paymentForm.controls["billingAddressContactContactNumber"]!=undefined ? this.paymentForm.controls["billingAddressContactContactNumber"].value : undefined,
      BillingContactAlternativeNumber:this.paymentForm.controls["billingAddressContactAlternativeContactNumber"]!=undefined ? this.paymentForm.controls["billingAddressContactAlternativeContactNumber"].value : undefined,
      BillingContactEmail:this.paymentForm.controls["billingAddressContactEmail"]!=undefined ? this.paymentForm.controls["billingAddressContactEmail"].value : undefined,
      BillingCustomerId:this.paymentForm.controls["billingAddressCustomerId"]!=undefined ? this.paymentForm.controls["billingAddressCustomerId"].value : undefined,
      BillingInvoiceId:this.paymentForm.controls["billingAddressInvoiceId"]!=undefined ? this.paymentForm.controls["billingAddressInvoiceId"].value : undefined,
      BillinginvoiceDescription:this.paymentForm.controls["billingAddressInvoiceDescription"]!=undefined ? this.paymentForm.controls["billingAddressInvoiceDescription"].value : undefined,
      BillingAddress1:this.paymentForm.controls["billingAddressAddressLine1"]!=undefined ? this.paymentForm.controls["billingAddressAddressLine1"].value : undefined,
      BillingAddress2:this.paymentForm.controls["billingAddressAddressLine2"]!=undefined ? this.paymentForm.controls["billingAddressAddressLine2"].value : undefined,
      BillingAddress3:this.paymentForm.controls["billingAddressAddressLine3"]!=undefined ? this.paymentForm.controls["billingAddressAddressLine3"].value : undefined,
      BillingAddress4:this.paymentForm.controls["billingAddressAddressLine4"]!=undefined ? this.paymentForm.controls["billingAddressAddressLine4"].value : undefined,
      BillingAddress5:this.paymentForm.controls["billingAddressAddressLine5"]!=undefined ? this.paymentForm.controls["billingAddressAddressLine5"].value : undefined,
      BillingSurburb:this.paymentForm.controls["billingAddressSurburb"]!=undefined ? this.paymentForm.controls["billingAddressSurburb"].value : undefined,
      BillingCity:this.paymentForm.controls["billingAddressCity"]!=undefined ? this.paymentForm.controls["billingAddressCity"].value : undefined,
      BillingProvince:this.paymentForm.controls["billingAddressProvince"]!=undefined ? this.paymentForm.controls["billingAddressProvince"].value : undefined,
      BillingCountryCode:this.paymentForm.controls["billingAddressCountryCode"]!=undefined ? this.paymentForm.controls["billingAddressCountryCode"].value : undefined,
      BillingCountry:this.paymentForm.controls["billingAddressCountry"]!=undefined ? this.paymentForm.controls["billingAddressCountry"].value : undefined,
      BillingPostalCode:this.paymentForm.controls["billingAddressPostalCode"]!=undefined ? this.paymentForm.controls["billingAddressPostalCode"].value : undefined,
      ShippingContactFirstName:this.paymentForm.controls["shippingAddressContactFirstName"]!=undefined ? this.paymentForm.controls["shippingAddressContactFirstName"].value : undefined,
      ShippingContactLastName:this.paymentForm.controls["shippingAddressContactLastName"]!=undefined ? this.paymentForm.controls["shippingAddressContactLastName"].value : undefined,
      ShippingContactCompanyName:this.paymentForm.controls["shippingAddressContactCompanyName"]!=undefined ? this.paymentForm.controls["shippingAddressContactCompanyName"].value : undefined,
      ShippingContactNumber:this.paymentForm.controls["shippingAddressContactNumber"]!=undefined ? this.paymentForm.controls["shippingAddressContactNumber"].value : undefined,
      ShippingContactAlternativeNumber:this.paymentForm.controls["shippingAddressContactAlternativeNumber"]!=undefined ? this.paymentForm.controls["shippingAddressContactAlternativeNumber"].value : undefined,
      ShippingEmail:this.paymentForm.controls["billingAddressContactEmail"]!=undefined ? this.paymentForm.controls["billingAddressContactEmail"].value : undefined,
      ShippingTimeframe:this.paymentForm.controls["shippingAddressDeliveryTimeframe"]!=undefined ? this.paymentForm.controls["shippingAddressDeliveryTimeframe"].value : undefined,
      ShippingMethod:this.paymentForm.controls["shippingAddressShippingMethod"]!=undefined ? this.paymentForm.controls["shippingAddressShippingMethod"].value : undefined,
      ShippingAddress1:this.paymentForm.controls["shippingAddressAddressLine1"]!=undefined ? this.paymentForm.controls["shippingAddressAddressLine1"].value : undefined,
      ShippingAddress2:this.paymentForm.controls["shippingAddressAddressLine2"]!=undefined ? this.paymentForm.controls["shippingAddressAddressLine2"].value : undefined,
      ShippingAddress3:this.paymentForm.controls["shippingAddressAddressLine3"]!=undefined ? this.paymentForm.controls["shippingAddressAddressLine3"].value : undefined,
      ShippingAddress4:this.paymentForm.controls["shippingAddressAddressLine4"]!=undefined ? this.paymentForm.controls["shippingAddressAddressLine4"].value : undefined,
      ShippingAddress5:this.paymentForm.controls["shippingAddressAddressLine5"]!=undefined ? this.paymentForm.controls["shippingAddressAddressLine5"].value : undefined,
      ShippingSurburb:this.paymentForm.controls["shippingAddressSurburb"]!=undefined ? this.paymentForm.controls["shippingAddressSurburb"].value : undefined,
      ShippingCity:this.paymentForm.controls["shippingAddressCity"]!=undefined ? this.paymentForm.controls["shippingAddressCity"].value : undefined,
      ShippingProvince:this.paymentForm.controls["shippingAddressProvince"]!=undefined ? this.paymentForm.controls["shippingAddressProvince"].value : undefined,
      ShippingCountryCode:this.paymentForm.controls["shippingAddressCountryCode"]!=undefined ? this.paymentForm.controls["shippingAddressCountryCode"].value : undefined,
      ShippingCountry:this.paymentForm.controls["shippingAddressCountry"]!=undefined ? this.paymentForm.controls["shippingAddressCountry"].value : undefined,
      ShippingPostalCode:this.paymentForm.controls["shippingAddressPostalCode"]!=undefined ? this.paymentForm.controls["shippingAddressPostalCode"].value : undefined
   };
  }

}
